/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality. 
 */

import { createElement, modal } from "commonAssets/js/helpers"
import { instructions } from "./html/instructions"
import { ee } from "commonAssets/lib/selector"
import { ImportantDates } from "commonAssets/components/ImportantDates"
import { userLanguage } from "commonAssets/js/constants"
import { slugify } from "commonAssets/lib/slugify.js"

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log('[Initiate claim]...')

    _instructionsElement()

    _removeSomeElements()

    _addNewElements()

    _setPlaceholders()

    _updateFieldTypes()

    _nameFieldsHandler()

    return claim
}

function _instructionsElement() {
    const instructionsDiv = document.querySelector("#generalInstructions div")
    instructionsDiv.innerHTML = instructions
}

function _nameFieldsHandler() {

    const businessName = document.querySelector("#business_name")
    businessName
        ? businessName.parentElement.classList.add('w-100')
        : null

    const firstName = document.querySelector("#first_name")
    const lastName = document.querySelector("#last_name")
    firstName.value
        ? firstName.disabled = true
        : firstName.disabled = false
    lastName.value
        ? lastName.disabled = true
        : lastName.disabled = false

}

function _updateFieldTypes() {
    document.querySelector("#repair_facility_phone").type = "tel"
    document.querySelector("#repair_facility_phone").setAttribute("maxlength", "12")
    document.querySelector("#repair_facility_phone").setAttribute("autocomplete", "tel")
    document.querySelector("#repair_facility_phone").setAttribute("pattern", "[0-9]{3}-[0-9]{3}-[0-9]{4}")
    document.querySelector("#repair_facility_phone").setAttribute("inputmode", "numeric")
    document.querySelector("#repair_facility_phone").setAttribute("data-validate", "phone")
}

function _setPlaceholders() {
    document.querySelector("#signature_claiming_reimbursements").placeholder = "TYPE YOUR FULL NAME"
}

function _addNewElements() {
    const documentation = document.querySelector("#documentation")
    const attestationsDiv = createElement("div", {
        class: "bg-light text-dark border rounded p-3 mb-5",
        id: "attestations_div",
    })
    documentation.insertAdjacentElement("afterend", attestationsDiv)
    const attest_div = document.querySelectorAll(".attest_div")
    attest_div.forEach((div) => {
        attestationsDiv.appendChild(div)
    })
}

function _removeSomeElements() {
    const claimFieldsTitle = document.querySelector("#claimFieldsTitle")
    if (claimFieldsTitle) {
        claimFieldsTitle.remove()
    }

    const claimFieldsBody = document.querySelector("#claimFieldsBody")
    if (claimFieldsBody) {
        claimFieldsBody.remove()
    }

    const claimFormDeadline = document.querySelector("#claimFormDeadline")
    if (claimFormDeadline) {
        claimFormDeadline.remove()
    }

    const claimFormAlert = document.querySelector("#claim_form_alert")
    if (claimFormAlert) {
        claimFormAlert.remove()
    }
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log('[Load class member]...')
    // custom code goes here
    return claim
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log('[Process claim]...')

    _supportingDocumentation(claim)

    return claim
}

function _supportingDocumentation(claim) {
    // Check if the claim has supporting documentation
    const docsRequired = true;
    let docsFound = false;

    const uploads = claim.uploads
    if (uploads.length > 0) {
        docsFound = true
    }

    const files = claim.class_member.claim_files ? claim.class_member.claim_files : []
    if (files.length > 0) {
        docsFound = true
    }

    if (docsRequired && !docsFound) {
        const title = "Claim Submission Error"
        const message = "YOU MUST SUBMIT SUPPORTING DOCUMENTS WITH YOUR CLAIM. PLEASE UPLOAD YOUR DOCUMENTS AND TRY AGAIN."

        const documentation = document.querySelector("#documentation")
        documentation.classList.add("pulse", "border-danger")
        documentation.scrollIntoView({ behavior: "instant" })

        setTimeout(() => {
            documentation.classList.remove("pulse", "border-danger")
        }, 4000)

        modal(title, message)
        claim.flags.valid = false
        return claim
    }
    // debugger

    return claim
}

export const faqPageTables = () => {
    ee('.faq-container table').forEach((table) => {
        // remove all table attributes (align, border, cellspacing, cellpadding)

        table.classList.add('table', 'table-bordered')
        table.removeAttribute('align')
        table.removeAttribute('border')
        table.removeAttribute('cellspacing')
        table.removeAttribute('cellpadding')

        const thead = document.createElement('thead')
        const theadRow = document.createElement('tr')
        const tbody = table.querySelector('tbody')

        table.insertBefore(thead, tbody)
        thead.appendChild(theadRow)

        let countRow = 0
        table.querySelectorAll('tbody tr').forEach((tr) => {
            // theader row
            if (countRow === 0) {
                theadRow.innerHTML = tr.innerHTML
                theadRow.querySelectorAll('td').forEach((td) => {
                    td.removeAttribute('style')
                    td.classList.add('text-bg-dark', 'text-center', 'p-2', 'fw-bold')
                    td.querySelectorAll('p').forEach((p) => {
                        const text = p.textContent.replace(/\u00A0/g, '').trim();
                        if (text === '') {
                            p.remove();
                        }
                        p.removeAttribute('style')
                        p.classList.add('m-0', 'p-0')
                    })
                })
                tr.remove()
            }
            // tbody row
            tr.querySelectorAll('td').forEach((td) => {
                td.removeAttribute('style')
                td.classList.add('text-center', 'p-2')
                td.querySelectorAll('p').forEach((p) => {
                    const text = p.textContent.replace(/\u00A0/g, '').trim();
                    if (text === '') {
                        p.remove();
                    }
                    p.removeAttribute('style')
                    p.classList.add('m-0', 'p-0')
                })
            })
            countRow++;
        })
    })
}

export class customImportantDates extends ImportantDates {
    constructor(data) {
        super(data)
    }

    datesList() {
        const json = this.params.findResult;

        const cardList = createElement("ul");
        cardList.classList.add("list-group", "list-group-flush"); // Add classes to the element
        cardList.id = "impt-dates-body"; // Add an ID to the element

        const titles = json.lang[userLanguage].ImportantDates;
        const dates = json.ImportantDates;
        let dateID = 0;
        dates.forEach((li) => {
            const listItem = createElement("li");
            listItem.classList.add("list-group-item", "important-date"); // Add classes to the element

            const title = titles[dateID]?.Title;
            if (title) {
                listItem.id = slugify(title); // Add an ID to the element
            }

            const display_date = (title) => {
                return this.shouldDisplayAsDateTime(li, title)
                    ? this.dateTime(li.Date)
                    : this.dateString(li.Date);
            };
            const isPassed = new Date(li.Date) < new Date();
            const isClaimDeadline = title && title.toLowerCase().includes('claim deadline');
            const statusLabel = (isClaimDeadline && !isPassed)
                ? "UPDATED"
                : (isPassed ? "PASSED" : "");

            const timeElement = createElement("time", {
                class: "d-block fw-bold"
            });
            timeElement.textContent = display_date(title);

            const titleElement = createElement("span");
            titleElement.textContent = title || "";

            if (statusLabel) {
                const statusElement = createElement("span", {
                    class: "text-danger ms-2"
                });
                statusElement.textContent = statusLabel;
                titleElement.appendChild(statusElement);
            }

            listItem.appendChild(timeElement);
            listItem.appendChild(titleElement);

            cardList.appendChild(listItem);
            dateID++;
        });
        return cardList.outerHTML;
    }
}
